import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 33 32"
      className="design-iconfont"
      width="32"
      height="32"
    >
      <g fill="none" fillRule="evenodd">
        <path
          stroke="#AFBAC9"
          d="M16.928 1.5a14.512 14.5 0 1 0 0 29 14.512 14.5 0 1 0 0-29Z"
        />
        <path
          stroke="#6F6F6F"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M22.942 22 10.924 10.01M10.924 22l12.018-11.99"
        />
      </g>
    </svg>
  )
}
const CircleCloseIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
CircleCloseIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#fff',
}
// 参数类型
CircleCloseIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default CircleCloseIcon
